import { useContext } from "react";
import { KindOfOrder } from "../../../../types/enums";
import AddNoteButton from "../../../common/notes/components/AddNoteButton";
import { RefetchScope, PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function PurchaseOrderAddNoteButton() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	var companyIDs = [order.details.distributorID, order.details.cfiID];

	const params = {
		showNoteType: false,
		orderID: order.details.purchaseOrderID,
		kindOfOrder: KindOfOrder.PurchaseOrder,
		companyIDs: companyIDs,
		emailSubject: order.details.poNumber,
		onNoteAdded: () => refetchOrder(RefetchScope.Notes)
	}

	return (
		<>
			<AddNoteButton
				caption="Add Purchase Order Note"
				params={params}
			/>
		</>
	)
}
